import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const ClientBalances = ()=>{
    const [packageinstallation, setPackageinstallation] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`packageinstallation?page=${page}`);
            setPackageinstallation(data.data);
            setLastPage(data.meta.last_page);
            console.log(data);

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`packageinstallation/${id}`);
            setPackageinstallation(packageinstallation.filter((packageinstallation) => packageinstallation.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Client Balances'}>
            <InnerNav createLink={'/packageinstallationCreate'} listLink={'/packageinstallation'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Installation date </th>
                                    <th className="px-4 py-3">Client </th>
                                    <th className="px-4 py-3">Solar package </th>
                                    <th className="px-4 py-3">Installation location </th>
                                    <th className="px-4 py-3">Cost amount </th>
                                    <th className="px-4 py-3">Amount paid </th>
                                    <th className="px-4 py-3">Balance amount </th>
                                    <th className="px-4 py-3">Monthly installment amount </th>
                                    <th className="px-4 py-3">Tracking MSISDN </th>
                                    <th className="px-4 py-3">Longitude </th>
                                    <th className="px-4 py-3">Latitude </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {packageinstallation.map((packageinstallation)=>{
                                         return(
                                             <tr key={packageinstallation.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{packageinstallation.id}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.installation_date}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.client.name}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.SolarPackage.package_name}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.installation_location}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.cost_amount}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.amount_paid}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.balance_amount}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.monthly_installment_amount}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.tracking_msisdn}</td>
                                                 <td className="px-4 py-3 text-sm"> </td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.latitude}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/packageinstallation/${packageinstallation.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(packageinstallation.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default ClientBalances;